import { z } from 'zod';

/**
 * Where E7 goes after "Stop copying this channel" (S9 R16): the Channels tab. A constant, not an
 * import of the Channels feature, which imports this one (`import-x/no-cycle`);
 * `AppRoutes.test.tsx` keeps it equal to `CHANNELS_ROUTE` (S9 AC17).
 */
export const AFTER_STOP_PATH = '/channels';

const StoppedCopyingSchema = z.object({
  stoppedCopying: z.object({ name: z.string().min(1).nullable() }),
});

/**
 * The navigation state E7 hands to E12 after a removal (S9 R16, P6): the channel's name, or
 * `null` when E7 did not know it (Q108). In the router's memory only: no browser storage.
 */
export function stoppedCopyingState(name: string | null): z.infer<typeof StoppedCopyingSchema> {
  return { stoppedCopying: { name } };
}

/** Reads that state on E12; `null` when the trader arrived any other way. */
export function readStoppedCopying(state: unknown): { readonly name: string | null } | null {
  const parsed = StoppedCopyingSchema.safeParse(state);
  return parsed.success ? parsed.data.stoppedCopying : null;
}
